<div class="ion-page">
  <ion-header>
    <ion-toolbar mode="md" color="dark">
      <ion-title>{{ 'posManager.managerMenu' | transloco }}</ion-title>
      <ion-buttons slot="end">
        <ion-button (click)="close()">
          <ion-icon name="close-outline" size="large"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <ion-list>
      <ion-item
        class="large-padding-item"
        button
        detail
        *ngFor="let item of filterNavigationItems"
        (click)="onGoTo(item.routerLink)">
        <ng-container *ngIf="item.icon as icon">
          <ion-icon
            *ngIf="icon.svgIcon as src"
            [src]="src"
            slot="start"
            size="large"></ion-icon>
          <fa-icon
            *ngIf="icon.faIcon as icon"
            [icon]="icon"
            slot="start"
            class="fs-px-32"></fa-icon>
        </ng-container>
        <ion-label>{{ item.name | transloco }}</ion-label>
      </ion-item>

      <ion-item
        class="large-padding-item"
        button
        detail
        [routerLink]="PagePath.SUPPORT">
        <ion-icon name="cog" slot="start" size="large"></ion-icon>
        <ion-label>{{ 'tools.support' | transloco }}</ion-label>
      </ion-item>
    </ion-list>
  </ion-content>
  <ion-footer>
    <ion-toolbar mode="md" color="light">
      <ion-buttons slot="start">
        <ion-button
          color="orange"
          fill="solid"
          mode="md"
          size="small"
          (click)="backToPos()">
          <ion-icon name="chevron-back-outline"></ion-icon>
          {{ 'posManager.backToPOS' | transloco }}
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-footer>
</div>
